import axios, {AxiosResponse} from 'axios';
import {ISessionXpedition} from '../sessions/interfaces';

export const getSessionsApi = (): Promise<AxiosResponse<ISessionXpedition[]>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/xpedition/sessions`
  );
};
